import { ColumnFilter, ColumnSort } from '@tanstack/react-table'
import { Row as TableRow } from '@tanstack/table-core'

import { isEmpty } from '@/helpers/type-guards'
import { Direction, Filter, SortBy } from '@/models/table'

export const getSortDirection = (sortBy: Array<SortBy | ColumnSort>): Direction | null => {
  return isEmpty(sortBy) ? null : sortBy[0].desc ? Direction.DESC : Direction.ASC
}

export const getSortField = (sortBy: Array<SortBy | ColumnSort>): string | null => {
  return isEmpty(sortBy) ? null : sortBy[0].id
}

export const getTableFilters = (filters: Array<Filter | ColumnFilter>): { [key: string]: string } | null => {
  return isEmpty(filters)
    ? null
    : filters.reduce((obj, item) => {
        obj[item.id] = item.value

        return obj
      }, {})
}

export const enumToInitialValues = <T extends object>(Enum: { [key: string]: string }): T => {
  const enumsVal: { [key: string]: string } = {}
  Object.values(Enum).forEach((key: string) => {
    enumsVal[key] = ''
  })

  return enumsVal as T
}

export const arrayToInitialValues = (array: Array<string>): { [key: string]: string } => {
  const objectVal: { [key: string]: string } = {}
  Object.values(array).forEach((key: string) => {
    objectVal[key] = ''
  })

  return objectVal
}

export const getTotal = <TData>(rows: TableRow<TData>[], columnId: string) =>
  rows.reduce((total, row) => total + Number(row.getValue(columnId)), 0)
